/* eslint-disable camelcase */
import React, {
    useState, useEffect, useCallback, useContext, useMemo
} from 'react';
import _ from 'lodash';
import { Link } from 'gw-components-platform-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadata } from '@jutro/uiconfig';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import { ServiceRequestService } from 'gw-capability-servicerequest';
import { useAuthentication } from 'gw-digital-auth-react';
import {
    Loader,
} from '@jutro/components';

import metadata from './LandingPage.metadata.json5';
import messages from './LandingPage.messages';
import styles from './LandingPage.module.scss';


const dueDateCell = (serviceRequestCell) => {
    const { dueDate } = serviceRequestCell;
    if (dueDate === undefined) {
        return '';
    }
    const dueDateFormatted = moment(dueDate).format('DD/MM/YYYY');
    return dueDateFormatted;
};

const serviceTypeCell = ({ services }) => {
    if (typeof services === 'undefined') {
        return '';
    }
    return services.join(', ');
};

const searchTableFilter = (filterValue) => (row) => {
    const val = filterValue.toLowerCase();
    return (
        row.customerContact.toLowerCase().includes(val)
            || row.claimID.toLowerCase().includes(val)
            || row.services.some((item) => item.toLowerCase().includes(val))
    );
};

function LandingPage() {
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const [serviceRequestData, setServiceRequestData] = useState([]);
    const [quoteRequestData, setQuoteRequestData] = useState([]);
    const [salvageBidsData, setSalvageBidsData] = useState([]);
    const [isLoading, setLoadingState] = useState(false);

    const filterServiceItems = useCallback((serviceItems) => {
        // second condition checks if request has a approved quote attached to it
        // if that's the case then move the request to service requests category
        const serviceRequests = serviceItems.filter((item) => (item.requestKind === 'serviceonly'
            || (item.requestKind === 'quoteandservice' && item.nextStepCode === 'FinishWork')) && item.serviceKind_EXT !== 'salvage');
        const quoteRequests = serviceItems.filter((item) => (item.requestKind === 'quoteonly'
            || (item.requestKind === 'quoteandservice' && item.nextStepCode !== 'FinishWork')) && item.serviceKind_EXT !== 'salvage');
        const salvageBids = serviceItems.filter((item) => item.serviceKind_EXT === 'salvage');
        setQuoteRequestData(quoteRequests);
        setServiceRequestData(serviceRequests);
        setSalvageBidsData(salvageBids);
    }, []);

    useEffect(() => {
        setLoadingState(true);
        ServiceRequestService.getServiceRequestsForVendor(authHeader).then(
            filterServiceItems
        ).finally(() => {
            setLoadingState(false);
        });
        // disable re render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const statesForOperation = useMemo(() => {
        return {
            specialistacceptedwork: translator(messages.serviceRequestProgressAcceptWork),
            specialistdeclined: translator(messages.serviceRequestProgressDeclineWork),
            specialistcompletedwork: translator(messages.serviceRequestProgressCompleteWork),
            specialistcanceled: translator(messages.serviceRequestProgressCancelWork),
            addinvoice: translator(messages.serviceRequestProgressAddInvoice),
            specialistresumedwork: translator(messages.serviceRequestProgressResumeWork),
            addquote: translator(messages.serviceRequestProgressAddQuote),
            requested: translator(messages.serviceRequstProgressRequested),
            inprogress: translator(messages.serviceRequstProgressInProgress),
            specialistwaiting: translator(messages.serviceRequstProgressVendorWaiting),
            declined: translator(messages.serviceRequstProgressDeclined),
            canceled: translator(messages.serviceRequstProgressCanceled),
            draft: translator(messages.serviceRequstProgressDraft),
            expired: translator(messages.serviceRequstProgressExpired),
            workcomplete: translator(messages.serviceRequstProgressWorkComplete),
            quoted: translator(messages.serviceRequstQuoteStatusQuoted),
            noquote: translator(messages.serviceRequstQuoteStatusNoQuote),
            approved: translator(messages.serviceRequstQuoteStatusApproved),
            waitingforquote: translator(messages.serviceRequstQuoteStatusWaitingforQuote),
            waitingforapproval: translator(messages.serviceRequstQuoteStatusWaitingforApproval),
            declined_EXT: translator(messages.serviceRequstProgressDeclined)
        };
    }, [translator]);

    // const progressCell = useCallback(({ defaultOperation }) => {
    //     return _.get(statesForOperation, defaultOperation, '');
    // }, [statesForOperation]);

    const progressCell = useCallback(({ status }) => {
        return _.get(statesForOperation, status, '');
    }, [statesForOperation]);

    const quoteStatusCell = useCallback(({ quoteStatus_EXT }) => {
        return _.get(statesForOperation, quoteStatus_EXT, '');
    }, [statesForOperation]);

    const salvageQuoteStatusCell = useCallback(() => {
        return 'Open for details';
    }, []);

    const nameCell = useCallback(({ claimInsured_EXT, serviceRequestNumber }) => {
        return (
            <Link to={`/service-request-details/${serviceRequestNumber}`}>
                {claimInsured_EXT}
            </Link>
        );
    }, []);

    const getTableOverrides = useCallback(() => {
        return {
            serviceTypeColumn: { onCell: serviceTypeCell },
            dueDateColumn: { onCell: dueDateCell },
            progressColumn: { onCell: progressCell },
            quoteStatusColumn: { onCell: quoteStatusCell },
            nameColumn: { onCell: nameCell },
            salvageQuoteStatusColumn: { onCell: salvageQuoteStatusCell }
        };
    }, [nameCell, progressCell, quoteStatusCell, salvageQuoteStatusCell]);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const override = {
        '@field': {
            labelPosition: 'left'
        },
        serviceRequestsTable: {
            data: serviceRequestData,
            filter: searchTableFilter
        },
        quoteRequestsTable: {
            data: quoteRequestData,
            filter: searchTableFilter
        },
        salvageBidsRequestsTable: {
            data: salvageBidsData,
            filter: searchTableFilter
        },
        ...getTableOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return renderContentFromMetadata(metadata.pageContent, override, resolvers);
}

export default withRouter(LandingPage);
